import React from "react";
import "./Tab.scss";

function Tab({ children }) {
  return <div className="tab">{children}</div>;
}

export default Tab;
